import type { ProductListItem } from '../services/products';

/**
 * The DB keeps one ProductInfo row per revision of a mix (legacy convention),
 * so raw product lists repeat the same mix once per revision. Collapse rows
 * whose visible label is identical, keeping the most recently created
 * revision. Rows that render differently (different code, plant or
 * description) are all kept — they are distinguishable choices.
 */
export const collapseProductRevisions = (
  products: ProductListItem[],
  label: (p: ProductListItem) => string,
): ProductListItem[] => {
  const byLabel = new Map<string, ProductListItem>();
  for (const p of products) {
    const key = label(p);
    const existing = byLabel.get(key);
    if (!existing || (p.date_create || '') > (existing.date_create || '')) {
      byLabel.set(key, p);
    }
  }
  return Array.from(byLabel.values());
};
